import { ValidationFailure } from "../../../errors/validation-failure";
import Guard from "../../../guard";
import { IMailRequest } from "../mail-request";
import { ValidatorBase } from "./validator-base";

export class MailValidator extends ValidatorBase {
    validate(mailRequest: IMailRequest): Array<ValidationFailure> {
        Guard.notNullOrUndefined(mailRequest);

        try {
            Guard.stringNotNullOrEmpty(mailRequest.mailTemplateName);
        } catch (error) {
            const failure = new ValidationFailure(`mailTemplateName cannot be null or whitespace.`);
            this.addFailure(failure);
        }

        return this.getFailures();
    }
}
